<template>
  <div class="category table-responsive" v-bind:id="category_slug">
    <header>
      <h2>{{c.name }}</h2>
      <StoragePopover :category="c"/>
    </header>
    <div class="description" v-if="show_description" v-html="c.description"></div>
    <div class="products" v-show="show_products">
      <table class="table table-striped table-sm">
        <thead>
          <tr>
            <th class="th_info">{{ $t('message.photo') }}</th>
            <th class="th_parameters">{{ $t('message.parameters') }}</th>
            <th class="th_blank"></th>
          </tr>
        </thead>
        <tbody>
          <Product v-for="item in c.products" :key="item.id" :product="item"/>
        </tbody>
      </table>
    </div>
    <div class="subcategory">
      <Category v-for="item in c.children" :key="item.id" :c="item"></Category>
    </div>
  </div>
</template>

<script>
import { helpers } from "./mixins/helpers";
import Product from "./Product.vue";
import StoragePopover from "./Category/StoragePopover.vue";

export default {
  mixins: [helpers],
  components: {
    Product,
    StoragePopover
  },
  name: "Category",
  data() {
    return {};
  },
  props: {
    c: {
      type: Object,
      required: true
    }
  },
  computed: {
    show_description () {
      return this.c.description;
    },
    show_products () {
      return this.c.products.length !== 0;
    },
    category_slug () {
      return this.to_slug(this.c.name);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.category {
  overflow: hidden;
  width: 100%;
  header {
    background: #23497f;
    padding: 15px 0;
    position: relative;
    h2 {
      margin: 0;
      font-size: 0.8em;
      text-align: center;
      color: #fff;
      text-transform: uppercase;
      @media (min-width: 576px) {
        font-size: 1em;
      }
      @media (min-width: 768px) {
        font-size: 1.2em;
      }
    }
    .v-popover {
      position: absolute;
      right: 5px;
      top: -1px;
      @media (min-width: 768px) {
        right: 10px;
        top: 3px;
      }
      .btn,
      .btn:not(:disabled):not(.disabled).active,
      .btn:not(:disabled):not(.disabled):active,
      .show > .btn.dropdown-toggle {
        background: #fff;
        color: #23497f;
        border-color: #fff;
      }
    }
  }
  .subcategory {
    margin: 15px 0;
    header {
      background: none;
      h2 {
        font-size: 0.7em;
        padding: 5px 40px;
        background: none;
        color: #23497f;
        text-align: center;
        font-weight: 700;
        border: 0;
        text-transform: uppercase;
        @media (min-width: 768px) {
          font-size: 1.2em;
          padding-right: 5px 0;
        }
      }
      .v-popover {
        right: 5px;
        top: 13px;
        .btn,
        .btn:not(:disabled):not(.disabled).active,
        .btn:not(:disabled):not(.disabled):active,
        .show > .btn.dropdown-toggle {
          padding: 0.075rem 0.45rem;
          background: #23497f;
          color: #fff;
          border-color: #23497f;
        }
      }
    }
    .description {
      font-size: 0.7em;
      @media (min-width: 768px) {
        font-size: 0.9em;
      }
    }
    .subcategory {
      header {
        h2 {
          font-size: 0.7em;
          border-left: 31px solid #23497f;
          padding: 7.5px 0;
          background: none;
          color: #23497f;
          text-align: left;
          font-weight: 700;
          padding-left: 10px;
          border-bottom: 1px solid #23497f;
          border-right: 1px solid #23497f;
          border-top: 1px solid #23497f;
          text-transform: uppercase;
          @media (min-width: 768px) {
            font-size: 0.9em;
            padding-right: 40px;
          }
        }
        .v-popover {
          top: 11px;
          right: 3px;
          @media (min-width: 768px) {
            right: 5px;
            top: 13px;
          }
        }
      }
      .description {
        font-size: 0.7em;
        @media (min-width: 768px) {
          font-size: 0.9em;
        }
      }
      .subcategory {
        header {
          h2 {
            font-size: 0.7em;
            padding: 7.5px 0;
            padding-right: 40px;
            color: #23497f;
            text-align: left;
            font-weight: 700;
            border: 0;
            @media (min-width: 768px) {
              font-size: 0.9em;
              padding-right: 40px;
            }
          }
        }
      }
      .description {
        font-size: 0.7em;
        @media (min-width: 768px) {
          font-size: 0.9em;
        }
      }
    }
  }
}
.description {
  padding: 20px 0 30px 0;
  font-size: 0.8em;
}
table {
  .th_parameters {
    display: none;
    @media (min-width: 576px) {
      display: table-cell;
    }
  }
  .th_blank {
    display: none;
    @media (min-width: 576px) {
      display: table-cell;
    }
  }
}

table .th_cena {
  text-align: center;
}
table tr th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  color: #a8a8a8;
  font-weight: 300;
  font-size: 0.8em;
}
</style>



// WEBPACK FOOTER //
// src/components/Category.vue